import React from 'react';

import { Category, Permission, Product } from 'generated/graphql';

import { DraggableContainer } from 'components/DraggableContainer/DraggableContainer';
import { useVenueContext } from 'routes/Main';
import AddCategory from './AddCategory';

interface Props {
  categories: Category[];
  products: Product[];
  menuName: string;
  usesDoshiiMenuLogic: boolean;
}

const CategoryList: React.FC<Props> = ({ categories, products, menuName, usesDoshiiMenuLogic }) => {
  const { currentUser } = useVenueContext();
  const categoryNames: string[] = categories
    .filter((category) => category.mmId !== 'UNCATEGORISED')
    .map((category) => category.category.toLowerCase());
  const canEditItem = !!currentUser?.permissions?.includes(Permission.PublishMenu);

  return (
    <div className="container">
      <DraggableContainer
        wrapperStyle={() => ({
          width: 'auto',
          height: 112
        })}
        categories={categories}
        products={products}
      />
      {canEditItem && (
        <AddCategory categoryNames={categoryNames} menuName={menuName} usesDoshiiMenuLogic={usesDoshiiMenuLogic} />
      )}
    </div>
  );
};

export default CategoryList;
